import { resetAppointment } from 'actions';

import { CLEAR_PROFESSIONAL, SELECT_PROFESSIONAL } from './ActionTypes';

export function clearProfessional() {
  return {
    type: CLEAR_PROFESSIONAL,
  };
}

export function selectProfessional(professional) {
  return (dispatch, getState) => {
    const { appointment } = getState();

    dispatch({ type: SELECT_PROFESSIONAL, payload: professional });

    if (appointment?.professional?.guid !== professional?.guid) {
      dispatch(resetAppointment());
    }
  };
}
